import { useRef } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'


const CtinformationForm = ({ navigation, route }: any): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params


  const options2 = [
    { key: 1, value: 'No' },
    { key: 2, value: 'Yes' }
  ]
  const options1 = [
    { key: 1, value: 'Married Filing Jointly' },
    { key: 2, value: 'Qualifying Surviving Spouse' },
    { key: 3, value: 'Married Filing Seperately' },
    { key: 4, value: 'Single' },
    { key: 5, value: 'Head of Household' }
  ]

  const opmarriedjointly = [
    { key: "E", value: "Our expected combined annual gross income is less than or equal to $24,000 or I am claiming exemption under the Military  Spouses Residency Relief Act (MSRRA)* and no withholding is necessary" },
    {
      key: "A", value: "My spouse is employed and our expected combined annual gross income is greater than $24,000 and less than or equal to $100,500. See Certain Married Individuals, Page 2"
    },
    { key: "C", value: "My spouse is not employed and our expected combined annual gross income is greater than $24,000" },
    { key: "D", value: "My spouse is employed and our expected combined annual gross income is greater than $100,500" },
    { key: "D", value: "I have significant nonwage income and wish to avoid having too little tax withheld" },
    { key: "D", value: "I am a nonresident of Connecticut with substantial other income" }
  ]

  const opsurvingspouse = [
    { key: "E", value: "My expected annual gross income is less than or equal to $24,000 or I am claiming exemption under the MSRRA* and no withholding is necessary" },
    { key: "C", value: "My expected annual gross income is greater than $24,000" },
    { key: "D", value: "I have significant nonwage income and wish to avoid having too little tax withheld" },
    { key: "D", value: "I am a nonresident of Connecticut with substantial other income" }
  ]
  const marriedseperate = [
    { key: "E", value: "My expected annual gross income is less than or equal to $12,000 or I am claiming exemption under the MSRRA* and no withholding is necessary" },
    { key: "A", value: "My expected annual gross income is greater than $12,000" },
    { key: "D", value: "I have significant nonwage income and wish to avoid having too little tax withheld" },
    { key: "D", value: "I am a nonresident of Connecticut with substantial other income" }
  ]
  const single = [
    { key: "E", value: "My expected annual gross income is less than or equal to $15,000 and no withholding is necessary" },
    { key: "F", value: "My expected annual gross income is greater than $15,000" },
    { key: "D", value: "I have significant nonwage income and wish to avoid having too little tax withheld" },
    { key: "D", value: "I am a nonresident of Connecticut with substantial other income" }
  ]

  const HeadofHousehold = [
    { key: "E", value: "My expected annual gross income is less than or equal to $19,000 and no withholding is necessary" },
    { key: "B", value: "My expected annual gross income is greater than $19,000" },
    { key: "D", value: "I have significant nonwage income and wish to avoid having too little tax withheld" },
    { key: "D", value: "I am a nonresident of Connecticut with substantial other income" }

  ]
  const intialValues = {
    filingStatus: null,
    additionalWithholdingAmount: "",
    reducedWithHoldingAmount: "",
    msraExcemption: "",
    stateOfResidence: "",
    withholdingCode: ""

  }
  const alschema = yup.object({
    filingStatus: yup
      .string()
      .required('Filing Status is a required field'),
    additionalWithholdingAmount: yup.string().nullable(),
    reducedWithHoldingAmount: yup.string().nullable(),
    msraExcemption: yup.string().required("MSRRA exemption is a required field"),
    withholdingCode: yup.string().required("Withholding Code is a required field"),
    stateOfResidence: yup.string().when("msraExcemption", (msraExcemption: any, schema) => {
      if (msraExcemption == 1) {
        return schema.required("State of residence is a required field")
      }
      return schema.nullable();
    }),
  })



  const { loading, postctonline } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()

  let filingdescription = ""



  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'CT Withholding Taxation '}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={alschema}
          onSubmit={async (values, actions) => {
            const data = {
              completeOnline: mode == "online" ? true : false,
              essUserKey: initializestore.initializeData.userkey,
              entityId: personalstore.personalData?.entityId,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              essObKey: essUserOnBoardingKey,
              filingStatus: filingdescription,
              withholdingCode: values?.withholdingCode,
              additionalWithholdingAmount: values?.additionalWithholdingAmount ? values?.additionalWithholdingAmount : null,
              reducedWithHoldingAmount: values?.reducedWithHoldingAmount ? values?.reducedWithHoldingAmount : null,
              msraExcemption: Number(values?.msraExcemption) == 0 ? false : true,
              stateOfResidence: values?.stateOfResidence
            }


            const response = await postctonline(data)


            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('Ctonline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                  filingdescription
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%', overflow: 'hidden' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Filing Status *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Filing Status"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.filingStatus
                      )}
                      onSelect={(option: any) => {

                        const filtered = options1.find((item) => (item.key == option))
                        filingdescription = filtered.value

                        props.setFieldValue('filingStatus', option - 1)
                        props.setFieldValue("withholdingCode", "")
                      }}
                      textColor="primary"
                    />
                    {props.touched.filingStatus &&
                      props.errors.filingStatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.filingStatus as string}
                        </Text>
                      )}
                  </View>
                </View>
                {props.values.filingStatus != null &&
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '50%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Withholding Code *'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      {Number(props.values.filingStatus) == 0 &&
                        <SelectKeyValue
                          title="Withholding Code"
                          options={opmarriedjointly}
                          selectedOption={
                            mapSelectValue(
                              opmarriedjointly,
                              props.values.withholdingCode
                            )}
                          onSelect={(option: any) => {

                            props.setFieldValue("withholdingCode", option)

                          }}
                          textColor="primary"
                        />}
                      {Number(props.values.filingStatus) == 1 &&
                        <SelectKeyValue
                          title="Withholding Code"
                          options={opsurvingspouse}
                          selectedOption={
                            mapSelectValue(
                              opsurvingspouse,
                              props.values.withholdingCode
                            )}
                          onSelect={(option: any) => {
                            props.setFieldValue("withholdingCode", option)
                          }}
                          textColor="primary"
                        />}
                      {Number(props.values.filingStatus) == 2 &&
                        <SelectKeyValue
                          title="Withholding Code"
                          options={marriedseperate}
                          selectedOption={
                            mapSelectValue(
                              marriedseperate,
                              props.values.withholdingCode
                            )}
                          onSelect={(option: any) => {
                            props.setFieldValue("withholdingCode", option)

                          }}
                          textColor="primary"
                        />}
                      {Number(props.values.filingStatus) == 3 &&
                        <SelectKeyValue
                          title="Withholding Code"
                          options={single}
                          selectedOption={
                            mapSelectValue(
                              single,
                              props.values.withholdingCode
                            )}
                          onSelect={(option: any) => {
                            props.setFieldValue("withholdingCode", option)

                          }}
                          textColor="primary"
                        />}
                      {Number(props.values.filingStatus) == 4 &&
                        <SelectKeyValue
                          title="Withholding Code"
                          options={HeadofHousehold}
                          selectedOption={
                            mapSelectValue(
                              HeadofHousehold,
                              props.values.withholdingCode
                            )}
                          onSelect={(option: any) => {
                            props.setFieldValue("withholdingCode", option)

                          }}
                          textColor="primary"
                        />}
                      {props.touched.withholdingCode &&
                        props.errors.withholdingCode && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.withholdingCode}
                          </Text>
                        )}
                    </View>
                  </View>}

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Reduced withholding amount per pay period '}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.reducedWithHoldingAmount}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('reducedWithHoldingAmount')(text)
                        }
                      }}
                    />

                    {props.touched.reducedWithHoldingAmount &&
                      props.errors.reducedWithHoldingAmount && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.reducedWithHoldingAmount as string}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Do you want to claim the MSRRA exemption *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Do you want to claim the MSRRA exemption"
                      options={options2}
                      selectedOption={mapSelectValue(
                        options2,
                        props.values.msraExcemption
                      )}
                      onSelect={(option: any) => {
                        if (option == 1) {
                          props.setFieldValue("stateOfResidence", "")

                        }
                        if (option == 2) {
                          props.setFieldValue("additionalWithholdingAmount", "")
                        }

                        props.setFieldValue('msraExcemption', option - 1)

                      }}
                      textColor="primary"
                    />
                    {props.touched.msraExcemption &&
                      props.errors.msraExcemption && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.msraExcemption}
                        </Text>
                      )}
                  </View>
                </View>
                {props.values.msraExcemption != 1 &&
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '50%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Additional withholding amount per pay period'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.additionalWithholdingAmount}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('additionalWithholdingAmount')(text)
                          }
                        }}
                      />

                      {props.touched.additionalWithholdingAmount &&
                        props.errors.additionalWithholdingAmount && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.additionalWithholdingAmount as string}
                          </Text>
                        )}
                    </View>
                  </View>
                }
                {Number(props.values.msraExcemption) == 1 && props.values.msraExcemption != null &&
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '50%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Enter state of legal residence/domicile *'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.stateOfResidence}

                        onChangeText={(text) => {

                          props.handleChange('stateOfResidence')(text)

                        }}
                      />

                      {props.touched.stateOfResidence &&
                        props.errors.stateOfResidence && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.stateOfResidence as string}
                          </Text>
                        )}
                    </View>
                  </View>}




                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>

            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}
export default CtinformationForm
